"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      connectivity = props.connectivity;
  var classes = ['connectivity-indicator', className];
  var healthIndex = Math.floor(connectivity.connection_health / 0.2);
  var healthClasses = ['none', 'weak', 'weak', 'strong', 'strong', 'strong'];
  var healthStatuses = ['Weak', 'Fair', 'Moderate', 'Good', 'Very good', 'Excellent'];
  classes.push(healthClasses[healthIndex]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.filter(function (c) {
      return c;
    }).join(' ')
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, connectivity.connection_health === 0 ? 'Disconnected' : healthStatuses[healthIndex]));
}